import { makeObservable, observable } from 'mobx';
import { LocalStorageGet, LocalStorageSet } from './Helpers';
import { ApiService } from './ApiService';
import { ApiURL } from '../AppConstants';

const LANGUAGE_KEY = 'language';
const TRANSLATIONS_KEY = 'translations';
const MAIN_LNG = 'English';

type TranslateKey = {
    languageKey: string,
    translationKey: string,
    value: string,
}
type TranslateDTO = {
    lng: string,
    translate: TranslateKey[]
}


export class LanguageService {
    @observable public langList: string[] = [];

    constructor () {
        makeObservable(this);
    }

    public async init () {
        const { data } = await ApiService.getData<string[]>(`${ApiURL.Languages}`);
        this.langList = data;
        const lang = LocalStorageGet<string>(LANGUAGE_KEY) || MAIN_LNG;
        await this.setLang(lang);
    }

    public async setLang (lang: string) {
        const cachedTranslations = lang ? LocalStorageGet<TranslateDTO>(`${TRANSLATIONS_KEY}`) : null;

        LocalStorageSet(LANGUAGE_KEY, lang);

        const { data } = await ApiService.getData<TranslateKey[]>(
            `${ApiURL.Translations}/${lang}`
        );

        const translations: TranslateDTO = {
            lng: lang,
            translate: data
        };

        LocalStorageSet(TRANSLATIONS_KEY, translations);

        if (
            JSON.stringify(cachedTranslations?.translate) !== JSON.stringify(data)
        ) {
            window.location.reload();
        }
    }

    get currentLanguage () {
        return LocalStorageGet<string>(LANGUAGE_KEY) || '';
    }

    get options () {
        return this.langList.map(e => {
            return { label: e, value: e };
        });
    }

}

export class LNG {
    public static Text (key: string) {
        const lang = LocalStorageGet<string>(LANGUAGE_KEY);
        const mockText = `{${key}}`;
        if (!lang) {
            return mockText;
        }

        const translations = LocalStorageGet<TranslateDTO>(TRANSLATIONS_KEY);

        return (
            translations?.translate.find(
                e => e.translationKey === key
            )?.value || mockText
        );
    }
}